module.exports = __webpack_public_path__ + "ts-white-bg.eBybBCX3.png";